import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import Button from "react-bootstrap/esm/Button";
import { loginRequest, graphConfig } from "../auth/authConfig";
import { ProfileData } from "./ProfileData";
import { callMsGraph } from "../auth/graph";
import axios from "axios";

export const ProfileContent = () => {
    const { instance, accounts } = useMsal();
    const [graphData, setGraphData] = useState(null);

    const name = accounts[0] && accounts[0].name;

    // useEffect(() => {
    //     async function RequestProfileData() {
    //         const response = await axios.get(graphConfig.graphMeEndpoint);
    //         setGraphData(response.data);
    //         console.log("Result from graphMeEndpoint!");
    //         console.log(response);
    //     }

    //     RequestProfileData();
    // }, []);

    return (
        <>
            <h5 className="card-title">Welcome {name}</h5>
            {/* {graphData ?
                <ProfileData graphData={graphData} />
                : <p>Loading...</p>
            } */}
        </>
    );
};